var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTldrLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1",
    "data-name": "Group 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1384 286.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: \"currentColor\";\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shape_1",
    "data-name": "Shape 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M692,143.2c95.49,94.58,225.38,146.83,360,143,124.94-3.56,243.43-55.13,332-143H692Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Shape_1_copy",
    "data-name": "Shape 1 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360,.2C225.38-3.63,95.49,48.61,0,143.2H692C603.43,55.33,484.94,3.75,360,.2Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTldrLogo);
export default __webpack_public_path__ + "static/media/tldr-logo.e8f6a0c60f537b492bd4842963bd849e.svg";
export { ForwardRef as ReactComponent };